import { Context } from '@nuxt/types'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default function ({ $pinia }: Context) {
  $pinia.use(piniaPluginPersistedstate)
}
